<template>
  <div class="container">
    <LoadingAnimation full-page v-if="loading" />
    <div class="d-flex flex-wrap">
      <PersonalAreaCheckboxList
        v-if="
          $route.name !== 'PersonalArea' &&
          $route.name !== 'PersonalAreaEdit' &&
          $route.name !== 'PersonalAreaEmployeeEdit'
        "
        :drawer="drawer"
        :checkbox="checkbox"
        ref="PersonalAreaCheckboxList"
        @changeCheckbox="onChangeCheckbox"
      />
      <div
        v-if="
          ((userData || commonUserData) && $route.name === 'PersonalAreaEmployeeEdit') ||
          $route.name === 'PersonalAreaEdit' ||
          $vuetify.breakpoint.smAndDown
        "
        class="content wrap"
      >
        <PersonalAreaAccordion
          :title="
            localStorage.translations.pages['setting-personal_area'].sections['basic_information']
          "
          ref-child-name="BasicData"
        >
          <BasicData
            :userData="personalAreaUser || personalAreaUserEdit ? userData : commonUserData"
            :editing="editing"
            ref="BasicData"
          />
        </PersonalAreaAccordion>
        <div class="content_grid" v-if="outputUserIsEmployee">
          <div class="content_grid_left">
            <div class="column">
              <PersonalAreaAccordion
                v-if="commonUserData && commonUserData.employee && admin"
                :title="'AllDate'"
              >
                <AllDate :employee="commonUserData.employee" />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                v-if="personalAreaUser || editReady"
                :title="localStorage.translations.pages.finance.pages.salary"
              >
                <Salary :data="salary_data" :editing="editing" />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections[
                    'karta-bezopasnosti-truda'
                  ]
                "
              >
                <SafetyCard
                  :userId="userId"
                  :safety_card="safety_card"
                  :editing="editing"
                  ref="SafetyCard"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                v-if="personalAreaUser || editReady"
                :title="localStorage.translations.pages['setting-personal_area'].labels['id-nomer']"
              >
                <IdNumber
                  :employeeId="employeeId"
                  :editing="editing"
                  :id_data="id_data"
                  ref="IdNumber"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                v-if="personalAreaUser || editReady || externalId"
                :title="externalIdLabel"
              >
                <ExternalId
                  :external-id="externalId"
                  :editing="editing"
                  ref="ExternalId"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer']
                "
              >
                <TaxNumber
                  :employeeId="employeeId"
                  :editing="editing"
                  :tax_data="tax_data"
                  ref="TaxNumber"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections['kontrakt']
                "
              >
                <Contract :userId="userId" :editing="editing" :contract="contract" ref="Contract" />
              </PersonalAreaAccordion>
            </div>
            <div class="column">
              <PersonalAreaAccordion v-if="admin" :title="'Персональный номер сотрудника в ProApp'">
                <PersonalNumber />
              </PersonalAreaAccordion>
              <StatusAndRole :roles="userData.roles" v-if="admin" />
              <PersonalAreaAccordion
                :title="localStorage.translations.pages['setting-personal_area'].labels['pasport']"
              >
                <Passport
                  :employeeId="employeeId"
                  :editing="editing"
                  :passport_data="passport_data"
                  ref="Passport"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections[
                    'nalogovaya-karta'
                  ]
                "
              >
                <TaxCard :userId="userId" :editing="editing" :tax_card="tax_card" ref="TaxCard" />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections['valttikortti']
                "
              >
                <Valttikortti
                  :userId="userId"
                  :editing="editing"
                  :valttikortti="valttikortti"
                  ref="Valttikortti"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections['spetsodezhda']
                "
              >
                <ClothesSizes
                  :employeeId="employeeId"
                  :editing="editing"
                  :clothesSizes="clothesSizes"
                  ref="ClothesSizes"
                />
              </PersonalAreaAccordion>
            </div>
          </div>
          <div class="content_grid_right">
            <div class="column">
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].labels['primechanie']
                "
              >
                <Note :notesData="notes" :employeeId="employeeId" ref="Note" :editing="editing" />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="
                  localStorage.translations.pages['setting-personal_area'].sections[
                    'adres-prozhivaniya-v-finlyandii'
                  ]
                "
              >
                <ContactAddress
                  :userId="userId"
                  :employeeId="employeeId"
                  :editing="editing"
                  :address="address"
                  :additional_address="additional_address"
                  ref="ContactAddress"
                />
              </PersonalAreaAccordion>
              <PersonalAreaAccordion
                :title="localStorage.translations.pages['setting-personal_area'].sections['navyki']"
              >
                <Skills :editing="editing" :skills="skills" :employeeId="employeeId" ref="Skills" />
              </PersonalAreaAccordion>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="
          $route.name === 'PersonalAreaEmployeeEdit' ||
          $route.name === 'PersonalAreaEdit' ||
          $vuetify.breakpoint.smAndDown
            ? 'abs'
            : 'mx-auto'
        "
      >
        <PdfGen
          :header-data="header_pdf"
          :content-data="data_pdf"
          :page-margins="[15, 50, 15, 30]"
          :images="images_pdf"
          :key="'pdf_' + pdf_pdf"
          :column-gap="10"
          invisible
          ref="pdf_gen"
          :name="
            (commonUserData
              ? commonUserData.first_name + ' ' + commonUserData.last_name + ' '
              : '') +
            currentData +
            '.pdf'
          "
        />
        <v-card width="950" tile>
          <v-sheet width="100%" class="py-2 px-5 d-flex justify-space-between align-center">
            <v-img
              v-if="companiesConfig.logo"
              :src="companiesConfig.logo['svg']"
              height="50"
              max-width="50"
              contain
            />
            <div class="f14">
              {{ currentData }}
            </div>
          </v-sheet>
          <v-divider />
          <div class="pa-5" v-if="checkbox">
            <BasicDataPdf
              :user-data="personalAreaUser || personalAreaUserEdit ? userData : commonUserData"
              :checkbox="checkbox.block1"
              :key="'pdf' + pdf_key"
            />
            <div class="content_column pt-5" :key="'pdf_info_' + pdf_key">
              <SalaryPdf
                v-if="
                  (personalAreaUser || editReady) &&
                  checkbox.block2.salary &&
                  !checkbox.block2.salary.value
                "
                :to="{
                  name: personalAreaUser ? 'PersonalAreaEdit' : 'PersonalAreaEmployeeEdit',
                  query: { select: 'Salary' },
                }"
                :data="salary_data"
                :editReady="editReady"
              />
              <PassportPdf
                v-if="checkbox.block2.passport && !checkbox.block2.passport.value"
                :passport_data="passport_data"
                ref="Passport1_par"
                :editReady="editReady"
              >
                <Passport
                  :employeeId="employeeId"
                  :passport_data="passport_data"
                  :on-save="onSave"
                  ref="Passport1"
                  :modal="true"
                />
              </PassportPdf>
              <IdNumberPdf
                v-if="checkbox.block2.id && !checkbox.block2.id.value"
                :id_data="id_data"
                ref="IdNumber1_par"
                :editReady="editReady"
              >
                <IdNumber
                  :employeeId="employeeId"
                  :id_data="id_data"
                  :on-save="onSave"
                  ref="IdNumber1"
                  :modal="true"
                />
              </IdNumberPdf>
              <ExternalIdPdf
                v-if="checkbox.block2.externalId && !checkbox.block2.externalId.value"
                :external-id="externalId"
                ref="ExternalId_par"
                :editReady="editReady"
              >
                <ExternalId
                  :external-id="externalId"
                  ref="ExternalId1"
                  :modal="true"
                />
              </ExternalIdPdf>
              <TaxNumberPdf
                v-if="checkbox.block2.taxNumber && !checkbox.block2.taxNumber.value"
                :tax_data="tax_data"
                ref="TaxNumber1_par"
                :editReady="editReady"
              >
                <TaxNumber
                  :employeeId="employeeId"
                  :tax_data="tax_data"
                  :on-save="onSave"
                  ref="TaxNumber1"
                  :modal="true"
                />
              </TaxNumberPdf>
              <TaxCardPdf
                v-if="checkbox.block2.taxCard && !checkbox.block2.taxCard.value"
                :tax_card="tax_card"
                ref="TaxCard_par"
                :editReady="editReady"
              >
                <TaxCard
                  :userId="userId"
                  :tax_card="tax_card"
                  :on-save="onSave"
                  ref="TaxCard1"
                  :modal="true"
                />
              </TaxCardPdf>
              <ContractPdf
                v-if="checkbox.block2.contract && !checkbox.block2.contract.value"
                :contract="contract"
                ref="Contract1_par"
                :editReady="editReady"
              >
                <Contract
                  :userId="userId"
                  :contract="contract"
                  :on-save="onSave"
                  ref="Contract1"
                  :modal="true"
                />
              </ContractPdf>
              <SafetyCardPdf
                v-if="checkbox.block2.safety && !checkbox.block2.safety.value"
                :safety_card="safety_card"
                ref="SafetyCard1_par"
                :editReady="editReady"
              >
                <SafetyCard
                  :userId="userId"
                  :safety_card="safety_card"
                  :on-save="onSave"
                  ref="SafetyCard1"
                  :modal="true"
                />
              </SafetyCardPdf>
              <ValttikorttiPdf
                v-if="checkbox.block2.valttikortti && !checkbox.block2.valttikortti.value"
                :valttikortti="valttikortti"
                ref="Valttikortti1_par"
                :editReady="editReady"
              >
                <Valttikortti
                  :userId="userId"
                  :valttikortti="valttikortti"
                  :on-save="onSave"
                  ref="Valttikortti1"
                  :modal="true"
                />
              </ValttikorttiPdf>
              <PersonalNumber v-if="admin" />
              <ContactAddressPdf
                v-if="checkbox.block3.address && !checkbox.block3.address.value"
                :address="address"
                :one="true"
              />
              <ContactAddressPdf
                v-if="checkbox.block3.address2 && !checkbox.block3.address2.value"
                :additional_address="additional_address"
                :two="true"
              />
              <ContactAddressPdf
                v-if="checkbox.block3.address3 && !checkbox.block3.address3.value"
                :additional_address="additional_address"
                :three="true"
              />
              <ContactAddressPdf
                v-if="checkbox.block3.address4 && !checkbox.block3.address4.value"
                :additional_address="additional_address"
                :four="true"
              />
              <ClothesSizesPdf
                v-if="checkbox.block3.clothes && !checkbox.block3.clothes.value"
                :clothesSizes="clothesSizes"
                ref="ClothesSizes1_par"
                :editReady="editReady"
              >
                <ClothesSizes
                  :employeeId="employeeId"
                  :clothesSizes="clothesSizes"
                  :on-save="onSave"
                  ref="ClothesSizes1"
                  :modal="true"
                />
              </ClothesSizesPdf>
              <SkillsPdf
                v-if="checkbox.block4.skills && !checkbox.block4.skills.value"
                :skills="skills"
              />
              <NotesPfd
                v-if="checkbox.block3.notes && !checkbox.block3.notes.value"
                :notes="notes"
                ref="Note1_par"
              >
                <Note
                  :notesData="notes"
                  :employeeId="employeeId"
                  :on-save="onSave"
                  ref="Note1"
                  :modal="true"
                />
              </NotesPfd>
            </div>
          </div>
          <v-divider />
          <FooterPdf />
        </v-card>
      </div>
    </div>
    <div
      v-if="checkbox.block4.printDocuments && !checkbox.block4.printDocuments.value"
      class="all_images"
    >
      <template v-for="(item, i) in allImages">
        <div v-if="item.images && typeof item.images === 'string'" :key="i" class="my-5 border">
          <div class="secondary--text font-weight-bold pa-5 f14">
            {{ item.text }}
          </div>
          <v-divider color="#cee2ed" />
          <div class="pa-5">
            <div
              v-if="item.images.split('.')[1] === 'pdf'"
              class="d-flex align-center justify-center mx-auto mt-5"
              style="background-color: #277faf; width: 60px; height: 60px; border-radius: 50%"
            >
              <PdfModalShow :url="item.images" class="mx-auto" btn-class="pdf__button" not-icon>
                <template slot="icon">
                  <PdfFile />
                </template>
              </PdfModalShow>
            </div>
            <v-img v-else :src="apiDomain + '/' + item.images" class="mx-auto mt-5" />
          </div>
        </div>
        <div v-else-if="item.images" :key="i" class="my-5 border">
          <div class="secondary--text font-weight-bold pa-5 f14">
            {{ item.text }}
          </div>
          <v-divider color="#cee2ed" />
          <div class="pa-5">
            <div v-for="(img, j) in item.images" :key="j" class="mt-5">
              <div
                v-if="img.split('.')[1] === 'pdf'"
                class="d-flex align-center justify-center mx-auto"
                style="background-color: #277faf; width: 60px; height: 60px; border-radius: 50%"
              >
                <PdfModalShow :url="img" class="mx-auto" btn-class="pdf__button" not-icon>
                  <template slot="icon">
                    <PdfFile />
                  </template>
                </PdfModalShow>
              </div>
              <v-img v-else :src="apiDomain + '/' + img" class="mx-auto mt-5" />
            </div>
          </div>
        </div>
      </template>
    </div>
    <div
      v-if="
        $route.name !== 'PersonalArea' &&
        $route.name !== 'PersonalAreaEdit' &&
        $route.name !== 'PersonalAreaEmployeeEdit'
      "
      class="d-flex"
    >
      <v-card width="500" tile flat v-if="$vuetify.breakpoint.xlOnly" color="transparent" />
      <v-card
        width="100%"
        max-width="950"
        tile
        flat
        class="mx-auto my-10 d-flex flex-wrap justify-space-around align-center"
        :class="$vuetify.breakpoint.mdAndDown ? 'flex-column' : ''"
        color="transparent"
      >
        <BaseButton
          v-if="$vuetify.breakpoint.lgAndDown"
          :text="localStorage.translations.pages.common.text.settings_pdf"
          default_icon="button-pdf"
          @click="$refs.PersonalAreaCheckboxList.drawer = !$refs.PersonalAreaCheckboxList.drawer"
          class="my-10"
        />
        <BaseButton
          @click="checkbox.block4.printDocuments.value ? onPrintPdf() : loadAllDocuments()"
          :text="Math.trunc(loadingProgress) + '%'"
          default_icon="button-create_pdf"
          round
          icon_only
        />
      </v-card>
    </div>
    <transition name="fade">
      <div class="fixedBtn">
        <BaseButton
          @click="checkbox.block4.printDocuments.value ? onPrintPdf() : loadAllDocuments()"
          :text="Math.trunc(loadingProgress) + '%'"
          default_icon="button-create_pdf"
          size="60"
          round
          icon_only
          class="mb-3"
        />
        <BaseTooltip
          v-if="editing"
          :tooltip="localStorage.translations.pages['setting-personal_area'].buttons.sohranit"
          max-content
        >
          <BaseButton @click="saveChanges" round size="60" icon_only default_icon="button-save" />
        </BaseTooltip>
        <template v-else>
          <BaseTooltip
            v-if="
              $userCheckAccess({ abilities: 'view_hr' }) &&
              ((personalAreaEmployee && commonUserData && commonUserData.employee) ||
                (personalAreaUser && userData && userData.employee))
            "
            :tooltip="localStorage.translations.pages.projects.pages['statistics']"
            max-content
          >
            <router-link
              :to="{
                name: 'employeeStatistic',
                params: {
                  userId: personalAreaEmployee ? commonUserData.id : userData.id,
                  employeeId: personalAreaEmployee
                    ? commonUserData.employee.id
                    : userData.employee.id,
                },
              }"
            >
              <BaseButton round size="60" icon_only>
                <template v-slot:icon>
                  <BaseIcon icon="pages-projects-statistic" color="white" />
                </template>
              </BaseButton>
            </router-link>
          </BaseTooltip>
          <BaseTooltip
            v-if="editReady"
            :tooltip="localStorage.translations.pages.common['buttons']['redaktirovat']"
            max-content
          >
            <BaseButton
              @click="
                $router.push({
                  name: personalAreaUser ? 'PersonalAreaEdit' : 'PersonalAreaEmployeeEdit',
                })
              "
              round
              size="60"
              icon_only
              default_icon="button-edit"
            />
          </BaseTooltip>
        </template>
      </div>
    </transition>
    <PdfDocumentCreate
      invisible
      indents
      :items="itemsCreatePdf"
      ref="createPdf"
      :key="itemsCreatePdfKey"
      :static-pdf="{
        headerData: header_pdf,
        contentData: data_pdf,
        pageMargins: [15, 50, 15, 30],
        images: images_pdf,
        columnGap: 10,
      }"
      :file-name="
        (commonUserData ? commonUserData.first_name + ' ' + commonUserData.last_name + ' ' : '') +
        currentData
      "
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import PersonalAreaCheckboxList from 'components/personalArea/PersonalAreaCheckboxList'
import PersonalAreaAccordion from 'components/personalArea/PersonalAreaAccordion'
import BasicData from 'components/personalArea/BasicData'
import AllDate from 'components/personalArea/AllDate'
import Note from 'components/personalArea/Note'
import StatusAndRole from 'components/personalArea/StatusAndRole'
import SafetyCard from 'components/personalArea/SafetyCard'
import IdNumber from 'components/personalArea/IdNumber'
import TaxNumber from 'components/personalArea/TaxNumber'
import PersonalNumber from 'components/personalArea/PersonalNumber'
import Passport from 'components/personalArea/Passport'
import Valttikortti from 'components/personalArea/Valttikortti'
import ClothesSizes from 'components/personalArea/ClothesSizes'
import TaxCard from 'components/personalArea/TaxCard'
import Contract from 'components/personalArea/Contract'
import Skills from 'components/personalArea/Skills'
import ExternalId from 'components/personalArea/ExternalId'
import ContactAddress from 'components/personalArea/ContactAddress'
import BasicDataPdf from 'components/personalArea/pdf/BasicDataPdf'
import PassportPdf from 'components/personalArea/pdf/PassportPdf'
import IdNumberPdf from 'components/personalArea/pdf/IdNumberPdf'
import ExternalIdPdf from 'components/personalArea/pdf/ExternalIdPdf'
import TaxNumberPdf from 'components/personalArea/pdf/TaxNumberPdf'
import ContractPdf from 'components/personalArea/pdf/ContractPdf'
import SafetyCardPdf from 'components/personalArea/pdf/SafetyCardPdf'
import ValttikorttiPdf from 'components/personalArea/pdf/ValttikorttiPdf'
import TaxCardPdf from 'components/personalArea/pdf/TaxCardPdf'
import ContactAddressPdf from 'components/personalArea/pdf/ContactAddressPdf'
import SkillsPdf from 'components/personalArea/pdf/SkillsPdf'
import ClothesSizesPdf from 'components/personalArea/pdf/ClothesSizesPdf'
import BaseButton from 'components/base/BaseButton'
import NotesPfd from 'components/personalArea/pdf/NotesPfd'
import FooterPdf from 'components/pdf/FooterPdf'
import PdfGen from 'components/pdf/pdfGen'
import LoadingAnimation from '../../components/LoadingAnimation'
import PdfDocumentCreate from 'components/pdf/pdfDocument/PdfDocumentCreate'
import PdfModalShow from 'components/pdf/PdfModalShow'
import PdfFile from 'components/icons/PdfFile'
import SalaryPdf from '../../components/personalArea/pdf/SalaryPdf.vue'
import Salary from '../../components/personalArea/Salary.vue'

export default {
  name: 'PersonalArea',
  components: {
    Salary,
    SalaryPdf,
    PdfFile,
    PdfModalShow,
    PdfDocumentCreate,
    LoadingAnimation,
    PersonalAreaCheckboxList,
    PersonalAreaAccordion,
    PdfGen,
    FooterPdf,
    NotesPfd,
    BaseButton,
    ClothesSizesPdf,
    SkillsPdf,
    ContactAddressPdf,
    ExternalIdPdf,
    TaxCardPdf,
    ValttikorttiPdf,
    SafetyCardPdf,
    ContractPdf,
    TaxNumberPdf,
    IdNumberPdf,
    PassportPdf,
    BasicDataPdf,
    BasicData,
    SafetyCard,
    AllDate,
    Note,
    StatusAndRole,
    IdNumber,
    TaxNumber,
    PersonalNumber,
    Passport,
    Valttikortti,
    ClothesSizes,
    TaxCard,
    Contract,
    Skills,
    ExternalId,
    ContactAddress,
  },
  data: () => ({
    msg: 'qwrty',
    save_pdf: false,
    pdf_pdf: 0,
    pdf_key: 0,
    drawer: false,
    loading: false,
    loadingProgress: 0,
    // checkAll: true,
    // indeterminate: false,
    date: null,
    menu: false,
    //dataBasic: null,
    safety_card: null,
    id_data: null,
    tax_data: null,
    passport_data: null,
    valttikortti: null,
    tax_card: null,
    contract: null,
    skills: [],
    admin: false,
    address: {
      street: null,
      city: null,
      zip: null,
    },
    additional_address: null,
    notes: null,
    employeeId: null,
    userId: null,
    clothesSizes: {},
    externalId: '',
    dates: ['2019-09-10', '2019-09-20'],
    data_pdf: null,
    itemsCreatePdf: [],
    itemsCreatePdfKey: 0,
    salary_data: {
      salary: 0,
      premium: 0,
    },
  }),
  created() {
    this.onDownloadPageData()
  },
  watch: {
    '$route.name'() {
      this.onDownloadPageData()
    },
    userData() {
      if (this.personalAreaUser || this.personalAreaUserEdit) {
        if (this.userData && this.userData.employee) {
          this.id_data = JSON.parse(this.userData.employee.id_data)
          this.tax_data = JSON.parse(this.userData.employee.tax_data)
          this.passport_data = JSON.parse(this.userData.employee.passport_data)

          this.address = {
            street: this.userData.employee.street,
            city: this.userData.employee.city,
            zip: this.userData.employee.zip,
          }

          this.notes = JSON.parse(this.userData.employee.notes)
          this.clothesSizes = {
            size_shoes: this.userData.employee.size_shoes,
            size_jacket: this.userData.employee.size_jacket,
            size_pants: this.userData.employee.size_pants,
            size_gloves: this.userData.employee.size_gloves,
          }
          this.externalId = this.userData.employee.external_id || ''
          this.skills = this.userData.employee.work_types
          this.salary_data = {
            salary: this.userData.employee.hour_salary,
            premium: this.userData.employee.hour_premium,
          }
        }
      }
    },
    userEmployeeDocGrid() {
      if (this.personalAreaUser || this.personalAreaUserEdit) {
        if (this.userEmployeeDocGrid !== null) {
          this.safety_card = this.userEmployeeDocGrid.find((i) => i.type === 'safety_card')
          this.valttikortti = this.userEmployeeDocGrid.find((i) => i.type === 'valttikortti')
          this.tax_card = this.userEmployeeDocGrid.find((i) => i.type === 'tax_card')
          this.contract = this.userEmployeeDocGrid.find((i) => i.type === 'contract')
          this.additional_address = this.userEmployeeDocGrid.find(
            (i) => i.type === 'additional_address',
          )
        }
      }
    },
    commonUserData() {
      if (this.personalAreaEmployee || this.personalAreaEmployeeEdit) {
        if (this.commonUserData && this.commonUserData.employee) {
          this.id_data = JSON.parse(this.commonUserData.employee.id_data)
          this.tax_data = JSON.parse(this.commonUserData.employee.tax_data)
          this.passport_data = JSON.parse(this.commonUserData.employee.passport_data)
          this.address = {
            street: this.commonUserData.employee.street,
            city: this.commonUserData.employee.city,
            zip: this.commonUserData.employee.zip,
          }
          this.notes = JSON.parse(this.commonUserData.employee.notes)
          this.clothesSizes = {
            size_shoes: this.commonUserData.employee.size_shoes,
            size_jacket: this.commonUserData.employee.size_jacket,
            size_pants: this.commonUserData.employee.size_pants,
            size_gloves: this.commonUserData.employee.size_gloves,
          }
          this.employeeId = this.commonUserData.employee.id
          this.userId = this.commonUserData.id
          this.skills = this.commonUserData.employee.work_types
          this.salary_data = {
            salary: this.commonUserData.employee.hour_salary,
            premium: this.commonUserData.employee.hour_premium,
          }
          this.externalId = this.commonUserData.employee.external_id || ''
        }
      }
    },
    employeeDocGrid() {
      if (this.personalAreaEmployee || this.personalAreaEmployeeEdit) {
        if (this.employeeDocGrid !== null) {
          this.safety_card = this.employeeDocGrid.find((i) => i.type === 'safety_card')
          this.valttikortti = this.employeeDocGrid.find((i) => i.type === 'valttikortti')
          this.tax_card = this.employeeDocGrid.find((i) => i.type === 'tax_card')
          this.contract = this.employeeDocGrid.find((i) => i.type === 'contract')
          this.additional_address = this.employeeDocGrid.find(
            (i) => i.type === 'additional_address',
          )
        }
      }
    },
    pdfGenReady() {
      if (this.pdfGenReady && this.save_pdf) {
        if (this.checkbox.block4.printDocuments.value) {
          this.$refs.pdf_gen.onDownload()
        } else {
          this.save_pdf = false
          this.loadAllDocuments()
        }
        this.setLoadingAnimationFullPage(false)
        this.loading = false
        this.save_pdf = false
      }
    },
  },
  computed: {
    ...mapGetters(['companiesConfig', 'apiDomain']),
    ...mapGetters('user', ['userData', 'checkUser', 'userEmployeeDocGrid']),
    ...mapGetters('employeeDoc', ['employeeDocGrid']),
    ...mapGetters('commonUser', ['commonUserData']),
    ...mapGetters(['loadingAnimationFullPage']),
    ...mapGetters('employeeSalaryInfo', ['employeeSalaryInfo']),
    dateRangeText() {
      return this.dates.join(' ~ ')
    },
    personalAreaUser() {
      return this.$route.name === 'PersonalArea'
    },
    personalAreaUserEdit() {
      return this.$route.name === 'PersonalAreaEdit'
    },
    personalAreaEmployee() {
      return this.$route.name === 'PersonalAreaEmployee'
    },
    personalAreaEmployeeEdit() {
      return this.$route.name === 'PersonalAreaEmployeeEdit'
    },
    outputUserIsEmployee() {
      return this.personalAreaUser ? this.userData && Boolean(this.userData.employee) : true
    },
    editReady() {
      return (
        (this.personalAreaEmployee &&
          this.$userCheckAccess({
            abilities: 'edit_employees',
          })) ||
        this.personalAreaUser
      )
    },
    externalIdLabel() {
      return (
        this.localStorage?.translations?.pages?.common?.text?.worker_id ||
        'Worker ID'
      )
    },
    editing() {
      return this.personalAreaUserEdit || this.personalAreaEmployeeEdit
    },
    checkbox() {
      let user =
        this.personalAreaUser || this.personalAreaUserEdit ? this.userData : this.commonUserData
      let temp = {
        block1: {},
        block2: {},
        block3: {},
        block4: {},
        block5: {},
      }
      if (user) {
        if (user.photo) {
          temp.block1.photo = {
            label: this.localStorage.translations.pages['setting-personal_area'].labels.photo,
            value: false,
          }
        }
        if (user.first_name || user.last_name) {
          temp.block1.name = {
            label: this.localStorage.translations.pages['setting-personal_area'].labels.full_name,
            value: false,
          }
        }
        if (user.dob) {
          temp.block1.dob = {
            label:
              this.localStorage.translations.pages['setting-personal_area'].labels
                .date_of_birth_and_age,
            value: false,
          }
        }
        if (user.email) {
          temp.block1.email = {
            label:
              this.localStorage.translations.pages['setting-personal_area'].labels[
                'elektronnaya-pochta'
              ],
            value: false,
          }
        }
        if (user.phone && user.phone.length > 0) {
          temp.block1.phone = {
            label: this.localStorage.translations.pages['setting-personal_area'].labels.telefon,
            value: false,
          }
        }
        if (this.outputUserIsEmployee) {
          if (this.salary_data && (this.personalAreaUser || this.editReady)) {
            temp.block2.salary = {
              label: this.localStorage.translations.pages.finance.pages.salary,
              field: 'salary_data',
              value: false,
              lines: 3,
            }
          }
          if (this.passport_data && (this.passport_data.text || this.passport_data.date_end)) {
            temp.block2.passport = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].labels['pasport'],
              value: false,
              field: 'passport_data',
              lines: 3,
            }
          }
          if (this.id_data && this.id_data.text && (this.personalAreaUser || this.editReady)) {
            temp.block2.id = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].labels['id-nomer'],
              value: false,
              field: 'id_data',
            }
          }
          if (this.externalId) {
            temp.block2.externalId = {
              label: this.externalIdLabel,
              value: false,
              field: 'externalId',
              lines: 1,
            }
          }
          if (this.tax_data && this.tax_data.text) {
            temp.block2.taxNumber = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].labels[
                  'nalogovyy-nomer'
                ],
              value: false,
              field: 'tax_data',
            }
          }
          if (this.tax_card) {
            let card = JSON.parse(this.tax_card.data)
            if (card.upper_wage_level || card.lower_percentage || card.top_percentage)
              temp.block2.taxCard = {
                label:
                  this.localStorage.translations.pages['setting-personal_area'].sections[
                    'nalogovaya-karta'
                  ],
                value: false,
                field: 'tax_card',
                lines: 4,
              }
          }
          if (this.contract) {
            let contract = JSON.parse(this.contract.data)
            temp.block2.contract = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].sections['kontrakt'],
              value: false,
              field: 'contract',
            }
          }
          if (this.safety_card) {
            let safety_card = JSON.parse(this.safety_card.data)
            if (safety_card.date_end) {
              temp.block2.safety = {
                label:
                  this.localStorage.translations.pages['setting-personal_area'].sections[
                    'karta-bezopasnosti-truda'
                  ],
                value: false,
                field: 'safety_card',
              }
            }
          }
          if (this.valttikortti) {
            let valttikortti = JSON.parse(this.valttikortti.data)
            if (valttikortti.date_end) {
              temp.block2.valttikortti = {
                label:
                  this.localStorage.translations.pages['setting-personal_area'].sections[
                    'valttikortti'
                  ],
                value: false,
                field: 'valttikortti',
              }
            }
          }
          if (this.address.street || this.address.city || this.address.zip) {
            temp.block3.address = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].sections[
                  'adres-prozhivaniya-v-finlyandii'
                ],
              value: false,
              field: 'address',
            }
          }
          let add = null
          if (this.additional_address && this.additional_address.data) {
            add = JSON.parse(this.additional_address.data)
            for (let i in add) {
              temp.block3['address' + Number(i + 2)] = {
                label: add[i].name,
                value: false,
                field: Number(i),
              }
            }
          }
          if (this.clothesSizes && Object.values(this.clothesSizes).join('')) {
            temp.block3.clothes = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].sections[
                  'spetsodezhda'
                ],
              value: false,
              field: 'clothesSizes',
              lines: 5,
            }
          }
          if (this.notes && this.notes.length > 0) {
            temp.block3.notes = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].labels['primechanie'],
              value: true,
              field: 'notes',
              lines: -1,
            }
          }
          if (this.skills && this.skills.length > 0) {
            temp.block4.skills = {
              label:
                this.localStorage.translations.pages['setting-personal_area'].sections['navyki'],
              value: true,
              field: 'skills',
              lines: -1,
            }
          }
        }
        temp.block4.printDocuments = {
          label: this.localStorage.translations.pages['setting-personal_area'].labels['all_docs'],
          value: true,
          field: 'doc',
          lines: -1,
        }
      }
      return temp
    },
    images_pdf() {
      let temp = {}
      let user =
        this.personalAreaUser || this.personalAreaUserEdit ? this.userData : this.commonUserData
      if (user && user.photo) {
        temp.photo = this.apiDomain + '/' + user.photo
      }
      return temp
    },
    header_pdf() {
      return {
        style: 'header',
        table: {
          widths: ['*', 150],
          body: [
            [
              {
                image: 'logo',
                width: 30,
                height: 30,
                margin: [11, 5, 10, 5],
              },
              {
                text: this.currentData,
                margin: [0, 17, 11, 5],
                alignment: 'right',
              },
            ],
          ],
        },
        layout: {
          hLineColor: '#d2d5d9',
          vLineWidth: function (i) {
            return 0
          },
        },
      }
    },
    // data_pdf() {
    //   return this.getDataPDF('data_pdf')
    // },
    pdfGenReady() {
      if (this.$refs.pdf_gen) return this.$refs.pdf_gen.documentReady
      return false
    },
    allImages() {
      let arr = []
      for (let i in this.checkbox.block2) {
        let field = this.checkbox.block2[i].field
        let name = ''
        if (field === 'passport_data')
          name = this.localStorage.translations.pages['setting-personal_area'].labels['pasport']
        if (field === 'id_data')
          name = this.localStorage.translations.pages['setting-personal_area'].labels['id-nomer']
        if (field === 'tax_data')
          name =
            this.localStorage.translations.pages['setting-personal_area'].labels['nalogovyy-nomer']
        if (field === 'tax_card')
          name =
            this.localStorage.translations.pages['setting-personal_area'].sections[
              'nalogovaya-karta'
            ]
        if (field === 'contract')
          name = this.localStorage.translations.pages['setting-personal_area'].sections['kontrakt']
        if (field === 'safety_card')
          name =
            this.localStorage.translations.pages['setting-personal_area'].sections[
              'karta-bezopasnosti-truda'
            ]
        if (field === 'valttikortti')
          name =
            this.localStorage.translations.pages['setting-personal_area'].sections['valttikortti']
        if (field === 'externalId') name = this.externalIdLabel
        if (!this.checkbox.block2[i].value) {
          const value = this[field]
          if (value && value.image) arr.push({ text: name, field: field, images: value.image })
          else if (value && value.data) {
            let temp = JSON.parse(value.data)
            arr.push({ text: name, field: field, images: temp.image || temp.file })
          }
        }
      }
      return arr
    },
    currentData() {
      return this.$formatDate(new Date().toJSON().slice(0, 10))
    },
  },
  methods: {
    ...mapActions('userInterface', ['onUserInterfacePage']),
    ...mapActions('user', [
      'getUser',
      'updateUser',
      'onUserEmployeeDocGrid',
      'onUserUpdateEmployeeData',
      'onUserCreateEmployeeDoc',
      'onUserUpdateEmployeeDoc',
    ]),
    ...mapActions('commonUser', ['onCommonUserData', 'onCommonUserUpdate']),
    ...mapMutations('commonUser', ['setCommonUserData']),
    ...mapActions('employeeDoc', [
      'onEmployeeDocGrid',
      'onCreateEmployeeDoc',
      'onUpdateEmployeeDoc',
    ]),
    ...mapActions('employeeSalaryInfo', ['onEmployeeSalaryInfo']),
    ...mapMutations('employeeDoc', ['setEmployeeDocGrid']),
    ...mapMutations(['setLoadingAnimationFullPage']),
    ...mapActions('employee', ['onEmployeeUpdate']),
    ...mapActions('navigationGuardian', ['offNavigationGuardianCheck']),
    async onDownloadPageData() {
      this.setLoadingAnimationFullPage(true)
      if (this.personalAreaUser || this.personalAreaUserEdit) {
        await Promise.all([this.getUser(), this.onUserEmployeeDocGrid()])
      } else if (this.personalAreaEmployee || this.personalAreaEmployeeEdit) {
        await this.downloadEployeeData()
      }
      this.pdf_key++
      this.setLoadingAnimationFullPage(false)
    },
    onChangeCheckbox(data) {
      // this.checkbox = data
      this.pdf_key++
    },
    async loadAllDocuments() {
      this.setLoadingAnimationFullPage(true)
      this.getDataPDF(true)
      let arr = []
      for (let i in this.allImages) {
        let check_text =
          this.allImages[i].images && typeof this.allImages[i].images === 'object'
            ? this.allImages[i].images.filter((i) => i && i.split('.')[1] !== 'pdf').length > 0
            : this.allImages[i].images && this.allImages[i].images.split('.')[1] !== 'pdf'
        if (check_text) arr.push({ text: this.allImages[i].text })
        if (this.allImages[i].images && typeof this.allImages[i].images === 'object') {
          let images = this.allImages[i].images.sort(function (a, b) {
            let nA = a ? a.split('.')[1] : '.png'
            let nB = b ? b.split('.')[1] : 'png'
            if (nA === 'pdf' && nB !== 'pdf') return 1
            if (nA !== 'pdf' && nB === 'pdf') return -1
            return 0
          })
          for (let id in images) {
            if (images[id].split('.')[1] === 'pdf') arr.push({ doc: images[id] })
            else arr.push({ image: images[id] })
          }
        } else arr.push({ image: this.allImages[i].images })
      }
      this.itemsCreatePdf = arr
      this.itemsCreatePdfKey++
      setTimeout(() => {
        this.setLoadingAnimationFullPage(false)
        this.$refs.createPdf.onStart()
      }, 100)
    },
    getDataPDF(dont_save) {
      this.save_pdf = false
      let user =
        this.personalAreaUser || this.personalAreaUserEdit ? this.userData : this.commonUserData
      let temp = []
      if (user) {
        let table = {
          style: 'text_lh',
          margin: [0, 10, 0, 10],
          table: {
            widths: [150, 'auto', '*', 'auto'],
            heights: [100, 5, 5],
            body: [
              [
                {},
                {
                  colSpan: 2,
                  columns: [
                    [
                      {
                        text:
                          this.checkbox.block1.name && this.checkbox.block1.name.value
                            ? ''
                            : user.first_name + ' ' + user.last_name,
                        style: 'header_black_12',
                        margin: [0, 5, 0, 10],
                      },
                      {
                        text:
                          (this.checkbox.block1.dob && this.checkbox.block1.dob.value) || !user.dob
                            ? ''
                            : this.formatDate(user.dob) + ' ' + this.getCurrentAge(user.dob),
                      },
                      {
                        text:
                          (this.checkbox.block1.email && this.checkbox.block1.email.value) ||
                          !user.email
                            ? ''
                            : user.email,
                        margin: [0, 10, 0, 0],
                      },
                    ],
                  ],
                },
                '',
                [],
              ],
              [
                '',
                {
                  text: '',
                },
                {
                  text: '',
                  colSpan: 2,
                },
                '',
              ],
              [
                '',
                {
                  text: '',
                },
                {
                  text: '',
                  colSpan: 2,
                },
                '',
              ],
            ],
          },
          layout: 'noBorders',
        }
        table.table.body[0][0] =
          (this.checkbox.block1.photo && this.checkbox.block1.photo.value) || !user.photo
            ? { text: '', fillColor: '#fcfcfc', rowSpan: 3 }
            : {
                image: 'photo',
                fit: [130, 130],
                alignment: 'center',
                rowSpan: 3,
                style: 'text',
              }
        if (this.checkbox.block1.phone && !this.checkbox.block1.phone.value) {
          for (let i in user.phone) {
            table.table.body[0][3].push({
              text: user.phone[i],
              margin: [0, 5, 0, 0],
            })
          }
        }
        temp.push(table)
        let columns = {
          style: ['text_lh'],
          columns: [[], []],
        }
        let count = 0
        let total = Math.round(
          (Object.values(this.checkbox.block2).reduce((sum, current) => {
            if (!current.value) {
              if (current.lines) {
                return sum + current.lines
              } else {
                return sum + 2
              }
            } else return sum
          }, 0) +
            Object.values(this.checkbox.block3).reduce((sum, current) => {
              if (!current.value) {
                if (current.lines) {
                  if (current.lines === -1) {
                    return sum + this[current.field].length + 1
                  } else {
                    return sum + current.lines
                  }
                } else {
                  return sum + 2
                }
              } else return sum
            }, 0)) /
            2,
        )
        let t = this.localStorage.translations.pages['setting-personal_area'].labels
        let ffff = [false, false, false, false]
        let ffft = [false, false, false, true]
        for (let i in this.checkbox.block2) {
          if (!this.checkbox.block2[i].value) {
            let field = this.checkbox.block2[i].field
            let inner = {
              style: 'text',
              margin: [0, 0, 0, 5],
              headerRows: 1,
              table: {
                widths: ['auto', '*'],
                body: [
                  [
                    {
                      text: this.checkbox.block2[i].label,
                      style: 'bold',
                      colSpan: 2,
                    },
                    '',
                  ],
                  [
                    { text: '', border: ffff },
                    { text: '', border: ffff },
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                vLineColor: '#d2d5d9',
                paddingTop: function (i, node) {
                  return i === 0 ? 6 : 3
                },
                paddingBottom: function (i, node) {
                  return i === 0 ? 5 : 0
                },
              },
            }
            if (field === 'salary_data') {
              count += 3
              inner.table.body.push([
                { text: t['salary_hourly'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.$formatCurrency(this.salary_data.salary) + ' ' + t['euro_hour'] || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
              inner.table.body.push([
                { text: t['personal_premium'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.$formatCurrency(this.salary_data.premium) + ' ' + t['euro_hour'] || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'passport_data') {
              count += 3
              inner.table.body.push([
                { text: t['nomer-pasporta'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.passport_data.text || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
              inner.table.body.push([
                { text: t['srok-deystiviya'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.formatDate(this.passport_data.date_end) || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'id_data') {
              count += 2
              inner.table.body.push([
                { text: t['id-nomer'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.id_data.text || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'externalId') {
              count += 1
              inner.table.body.push([
                { text: this.externalIdLabel + ':', style: ['h9'], border: ffff },
                {
                  text: this.externalId || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'tax_data') {
              count += 2
              inner.table.body.push([
                { text: t['nalogovyy-nomer'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.tax_data.text || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'tax_card') {
              count += 4
              let data = JSON.parse(this.tax_card.data)
              inner.table.body.push([
                {
                  text: t['verhniy-uroven-zarobotnoy-platy'] + ':',
                  style: ['h9'],
                  border: ffff,
                },
                {
                  text: data.upper_wage_level ? data.upper_wage_level + ' €' : '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
              inner.table.body.push([
                { text: t['nizhniy-protsent'] + ':', style: ['h9'], border: ffff },
                {
                  text: data.lower_percentage ? data.lower_percentage + ' %' : '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
              inner.table.body.push([
                { text: t['verhniy-protsent'] + ':', style: ['h9'], border: ffff },
                {
                  text: data.top_percentage ? data.top_percentage + ' %' : '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'contract') {
              count += 2
              let data = JSON.parse(this[field].data)
              inner.table.body.push([
                { text: t['srok-deystiviya'] + ':', style: ['h9'], border: ffff },
                {
                  text:
                    this.formatDate(data.date_end) ||
                    this.localStorage.translations.pages['setting-personal_area'].labels[
                      'termless'
                    ],
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            } else if (field === 'safety_card' || field === 'valttikortti') {
              count += 2
              let data = JSON.parse(this[field].data)
              inner.table.body.push([
                { text: t['srok-deystiviya'] + ':', style: ['h9'], border: ffff },
                {
                  text: this.formatDate(data.date_end) || '',
                  style: ['h9', 'bold'],
                  alignment: 'right',
                  border: ffff,
                },
              ])
            }
            columns.columns[count > total ? 1 : 0].push(inner)
          }
        }
        for (let i in this.checkbox.block3) {
          if (!this.checkbox.block3[i].value) {
            let field = this.checkbox.block3[i].field
            let inner = {
              style: 'text',
              margin: [0, 0, 0, 5],
              table: {
                widths: ['auto', '*'],
                headerRows: 1,
                body: [
                  [
                    {
                      text: this.checkbox.block3[i].label,
                      style: 'bold',
                      colSpan: 2,
                    },
                    '',
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                vLineColor: '#d2d5d9',
                paddingTop: function (i, node) {
                  return i === 0 ? 6 : field === 'skills' ? 5 : 3
                },
                paddingBottom: function (i, node) {
                  return i === 0 ? 5 : field === 'skills' ? 2 : 0
                },
              },
            }
            if (field === 'address') {
              count += 2
              inner.table.body.push([
                {
                  text:
                    (this.address.street || '') +
                    ' ' +
                    (this.address.city || '') +
                    ', ' +
                    (this.address.zip || ''),
                  style: ['h9', 'bold'],
                  border: ffff,
                  colSpan: 2,
                },
                '',
              ])
            } else if (field === 'clothesSizes') {
              count += 5
              for (let cs in this.clothesSizes) {
                inner.table.body.push([
                  {
                    text:
                      cs === 'size_gloves'
                        ? t['perchatki']
                        : cs === 'size_pants'
                        ? t['shtany']
                        : cs === 'size_jacket'
                        ? t['kurtka']
                        : t['obuv'],
                    style: ['h9'],
                    border: ffff,
                  },
                  {
                    text: this.clothesSizes[cs],
                    style: ['h9', 'bold'],
                    border: ffff,
                    alignment: 'right',
                  },
                ])
              }
            } else if (field === 'skills') {
              count += this.skills.length + 1
              for (let s in this.skills) {
                inner.table.body.push([
                  {
                    text: this.skills[s].name,
                    style: ['h9'],
                    border: Number(s) === this.skills.length - 1 ? ffff : ffft,
                    colSpan: 2,
                  },
                  '',
                ])
              }
            } else if (field === 'notes') {
              count += this.notes.length + 1
              for (let n in this.notes) {
                inner.table.body.push([
                  {
                    text: this.notes[n],
                    style: ['h9'],
                    border: ffff,
                    colSpan: 2,
                  },
                  '',
                ])
              }
            } else {
              if (this.additional_address && this.additional_address.data) {
                count += 2
                let data = JSON.parse(this.additional_address.data)
                if (data[field]) {
                  inner.table.body.push([
                    {
                      text:
                        (data[field].street || '') +
                        ' ' +
                        (data[field].city || '') +
                        ', ' +
                        (data[field].zip || ''),
                      style: ['h9', 'bold'],
                      border: ffff,
                      colSpan: 2,
                    },
                    '',
                  ])
                }
              }
            }
            columns.columns[count > total ? 1 : 0].push(inner)
          }
        }
        for (let i in this.checkbox.block4) {
          if (!this.checkbox.block4[i].value && this.checkbox.block4[i].field !== 'doc') {
            let field = this.checkbox.block4[i].field
            let inner = {
              style: 'text',
              margin: [0, 0, 0, 5],
              table: {
                widths: ['auto', '*'],
                headerRows: 1,
                body: [
                  [
                    {
                      text: this.checkbox.block4[i].label,
                      style: 'bold',
                      colSpan: 2,
                    },
                    '',
                  ],
                ],
              },
              layout: {
                hLineColor: '#d2d5d9',
                vLineColor: '#d2d5d9',
                paddingTop: function (i, node) {
                  return i === 0 ? 6 : field === 'skills' ? 5 : 3
                },
                paddingBottom: function (i, node) {
                  return i === 0 ? 5 : field === 'skills' ? 2 : 0
                },
              },
            }
            if (field === 'skills') {
              count += this.skills.length + 1
              for (let s in this.skills) {
                inner.table.body.push([
                  {
                    text: this.skills[s].name,
                    style: ['h9'],
                    border: Number(s) === this.skills.length - 1 ? ffff : ffft,
                    colSpan: 2,
                  },
                  '',
                ])
              }
            }
            columns.columns[count > total ? 1 : 0].push(inner)
          }
        }
        temp.push(columns)
      }
      this.pdf_pdf++
      this.data_pdf = temp
      this.save_pdf = !dont_save
      return temp
    },
    async onPrintPdf() {
      this.setLoadingAnimationFullPage(true)
      this.loading = true
      await this.getDataPDF()
    },
    changeAccordion(name) {
      this.accordion[name] ? (this.accordion[name] = false) : (this.accordion[name] = true)
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return (day ? day + '.' : '') + (month ? month + '.' : '') + year
    },
    getCurrentAge(date) {
      let currentAge = ((new Date().getTime() - new Date(date)) / (24 * 3600 * 365.25 * 1000)) | 0
      return this.ageToStr(currentAge)
    },
    ageToStr(age) {
      let txt
      let count = age % 100
      if (count >= 5 && count <= 20) {
        txt = this.localStorage.translations.pages.common.measure.years_old
      } else {
        count = count % 10
        if (count == 1) {
          txt = this.localStorage.translations.pages.common.measure.year
        } else if (count >= 2 && count <= 4) {
          txt = this.localStorage.translations.pages.common.measure.of_the_year
        } else {
          txt = this.localStorage.translations.pages.common.measure.years_old
        }
      }
      return (this.currentAge = age + ' ' + txt)
    },
    save(date) {
      this.$refs.menu.save(date)
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    async onSave() {
      let name = ''
      if (this.$refs.Passport1) name = 'Passport1'
      if (this.$refs.IdNumber1) name = 'IdNumber1'
      if (this.$refs.TaxNumber1) name = 'TaxNumber1'
      if (this.$refs.TaxCard1) name = 'TaxCard1'
      if (this.$refs.Contract1) name = 'Contract1'
      if (this.$refs.SafetyCard1) name = 'SafetyCard1'
      if (this.$refs.Valttikortti1) name = 'Valttikortti1'
      if (this.$refs.ClothesSizes1) name = 'ClothesSizes1'
      if (this.$refs.Note1) name = 'Note1'
      if (
        name === 'ClothesSizes1' ||
        name === 'Note1' ||
        name === 'TaxCard1' ||
        ((name === 'Passport1' ||
          name === 'SafetyCard1' ||
          name === 'IdNumber1' ||
          name === 'TaxNumber1' ||
          name === 'Contract1' ||
          name === 'Valttikortti1') &&
          this.$refs[name].$refs.form.validate())
      ) {
        let doc = ''
        let docRequests = []
        let dd = null
        let userData = {}
        const checkDoc = (docData) => {
          if (docData !== true) {
            const routeName = this.$route.name
            let result = docData.id
              ? routeName === 'PersonalAreaEmployee'
                ? 'onUpdateEmployeeDoc'
                : 'onUserUpdateEmployeeDoc'
              : docData.user_id
              ? 'onCreateEmployeeDoc'
              : 'onUserCreateEmployeeDoc'
            docRequests.push(this[result](docData))
          }
        }
        const [data] = await Promise.all([this.$refs[name].saveChange()])
        if (
          name === 'Passport1' ||
          name === 'IdNumber1' ||
          name === 'TaxNumber1' ||
          name === 'ClothesSizes1'
        ) {
          userData = { ...data }
        } else {
          checkDoc(data)
        }
        if (
          this.$route.name === 'PersonalAreaEmployee' &&
          this.commonUserData &&
          this.commonUserData.employee
        ) {
          if (Object.keys(userData).length) {
            userData.id = this.commonUserData.employee.id
          }
        }
        await Promise.all([
          Object.keys(userData).length
            ? this[
                this.$route.name === 'PersonalAreaEmployee'
                  ? 'onEmployeeUpdate'
                  : 'onUserUpdateEmployeeData'
              ](userData)
            : true,
          ...docRequests,
        ]).then(() => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
          this.$refs[name + '_par'].$refs.inner.closeDialog()
          this.offNavigationGuardianCheck()
          this.onDownloadPageData()
        })
      }
    },
    async saveChanges() {
      if (
        this.$refs.BasicData.validate() &&
        (!this.$refs.Passport || this.$refs.Passport.$refs.form.validate()) &&
        (!this.$refs.SafetyCard || this.$refs.SafetyCard.$refs.form.validate()) &&
        (!this.$refs.IdNumber || this.$refs.IdNumber.$refs.form.validate()) &&
        (!this.$refs.TaxNumber || this.$refs.TaxNumber.$refs.form.validate()) &&
        (!this.$refs.Contract || this.$refs.Contract.$refs.form.validate()) &&
        (!this.$refs.Valttikortti || this.$refs.Valttikortti.$refs.form.validate())
      ) {
        const completeMessage = () =>
          this.$store.dispatch(
            'popup/onMessage',
            {
              message:
                this.localStorage.translations.pages.common.notifications[
                  'izmeneniya-uspeshno-sohraneny'
                ],
              IsError: false,
            },
            { root: true },
          )
        const errorMessage = () => {
          this.$store.dispatch(
            'popup/onMessage',
            {
              message: this.localStorage.translations.pages.common.notifications['oshibka'],
              IsError: true,
            },
            { root: true },
          )
        }
        if (
          this[this.personalAreaUserEdit ? 'userData' : 'commonUserData'] &&
          this[this.personalAreaUserEdit ? 'userData' : 'commonUserData'].employee
        ) {
          let docRequests = []
          const checkDoc = (docData) => {
            if (docData !== true) {
              const routeName = this.$route.name
              let result = docData.id
                ? routeName === 'PersonalAreaEmployeeEdit'
                  ? 'onUpdateEmployeeDoc'
                  : 'onUserUpdateEmployeeDoc'
                : docData.user_id
                ? 'onCreateEmployeeDoc'
                : 'onUserCreateEmployeeDoc'
              docRequests.push(this[result](docData))
            }
          }
          const [
            clothesSizes,
            idNumber,
            taxNumber,
            passport,
            skills,
            contactAddress,
            safetyCard,
            valttikortti,
            taxCard,
            contract,
          ] = await Promise.all([
            this.$refs.ClothesSizes.saveChange(),
            this.$refs.IdNumber.saveChange(),
            this.$refs.TaxNumber.saveChange(),
            this.$refs.Passport.saveChange(),
            this.$refs.Skills.saveChange(),
            this.$refs.ContactAddress.saveChange(),
            this.$refs.SafetyCard.saveChange(),
            this.$refs.Valttikortti.saveChange(),
            this.$refs.TaxCard.saveChange(),
            this.$refs.Contract.saveChange(),
          ])
          let userData = {
            ...clothesSizes,
            ...idNumber,
            ...taxNumber,
            ...passport,
            ...skills,
            ...contactAddress.address,
          }
          if (
            this.$route.name === 'PersonalAreaEmployeeEdit' &&
            this.commonUserData &&
            this.commonUserData.employee
          ) {
            if (Object.keys(userData).length) {
              userData.id = this.commonUserData.employee.id
            }
          }
          checkDoc(contactAddress.additionalAddress)
          checkDoc(safetyCard)
          checkDoc(valttikortti)
          checkDoc(taxCard)
          checkDoc(contract)
          Promise.all([
            this.$refs.BasicData.saveChange(),
            Object.keys(userData).length
              ? this[
                  this.$route.name === 'PersonalAreaEmployeeEdit'
                    ? 'onEmployeeUpdate'
                    : 'onUserUpdateEmployeeData'
                ](userData)
              : true,
            ...docRequests,
          ])
            .then(async (resp) => {
              await this.offNavigationGuardianCheck()
              if (resp.find((i) => i !== true)) {
                completeMessage()
              }
              if (this.personalAreaUserEdit) {
                this.$router.push({ name: 'PersonalArea' })
              } else {
                this.$router.push({
                  name: 'PersonalAreaEmployee',
                  params: { userId: this.$route.params.userId },
                })
              }
              this.scrollToTop()
            })
            .catch(() => errorMessage())
        } else {
          this.$refs.BasicData.saveChange()
            .then((resp) => {
              if (resp !== true) {
                completeMessage()
              }
              if (this.personalAreaUserEdit) {
                this.$router.push({ name: 'PersonalArea' })
              } else {
                this.$router.push({
                  name: 'PersonalAreaEmployee',
                  params: { userId: this.$route.params.userId },
                })
              }
            })
            .catch(() => errorMessage())
        }
      } else {
        this.$store.dispatch(
          'popup/onMessage',
          {
            message:
              this.localStorage.translations.pages.common.notifications['fill_in_required_fields'],
            IsError: true,
          },
          { root: true },
        )
        this.scrollToTop()
        return
      }
    },
    async downloadEployeeData() {
      this.onCommonUserData(this.$route.params.userId)
      this.onEmployeeDocGrid(this.$route.params.userId)
    },
  },
  destroyed() {
    this.setCommonUserData()
    this.setEmployeeDocGrid()
  },
}
</script>

<style lang="scss" scoped>
.page {
  margin-top: 60px;
}

.content {
  padding: 30px 0;
  display: grid;
  grid-row-gap: 30px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-row-gap: 15px;
  }

  &_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 1fr;
      grid-row-gap: 15px;
    }

    &_left {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 15px;
      align-items: start;
      @media #{map-get($display-breakpoints, 'md-and-down')} {
        grid-template-columns: 1fr;
        grid-row-gap: 15px;
      }

      .column {
        display: grid;
        grid-row-gap: 15px;
      }
    }

    &_right {
      display: grid;
      grid-row-gap: 15px;
      align-items: start;

      .column {
        display: grid;
        grid-row-gap: 15px;
      }
    }
  }

  .pdf {
    width: max-content;
  }

  .btnSave {
    padding: 20px 40px;
    text-transform: uppercase;
    background-color: #277faf;
    border-radius: 28px;
    color: #ffffff;
    letter-spacing: 0.04em;
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    transition: 0.3s;
    margin-top: 30px;
    width: max-content;

    &:hover {
      background-color: #16558f;
    }
  }

  &_column {
    column-count: 2;
    column-gap: 20px;

    -webkit-column-count: 2;
    -moz-column-count: 2;
    -webkit-column-gap: 20px;
    -moz-column-gap: 20px;

    * {
      margin-bottom: 20px;
      break-inside: avoid-column !important;
    }
  }
}

:deep() .v-input.check {
  margin: 0 !important;

  .v-input__slot {
    min-height: 12px !important;
  }
}

.abs {
  position: absolute;
  overflow: scroll;
  width: 5px;
  height: 5px;
  left: -100px;
}

.border {
  border: 1px solid #bedbeb;
  border-radius: 4px;
}

.pa-5 {
  padding: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pdf__button {
  height: 50px !important;
  width: 50px !important;
  background-color: #277faf !important;
}

.all_images {
  @media #{map-get($display-breakpoints, 'xl-only')} {
    padding-left: 500px;
  }

  & > div {
    max-width: 950px !important;
    width: 60vw !important;
    margin: 0 auto;
  }
}
</style>
